import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {DateTime} from '@src/@types/DateTime';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import MomentDate from '../../MomentDate/MomentDate';

export default class TimeTenseColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn, Model> {
    protected get value(): any {
        const datetime = super.value as DateTime | null;
        if (!datetime) {
            return null;
        }

        return <MomentDate date={datetime} calendarSameElse="LLL" withWrapperTag="div"/>;
    }
}
